import { Helmet } from "react-helmet-async";

/**
 * Per-page SEO metadata: unique <title>, <meta description>, canonical URL,
 * and OpenGraph fields. Use one per public page.
 *
 * Canonicals always point to the non-www version to consolidate duplicate content
 * (audit found www.thebarracksbistro.in and thebarracksbistro.in are both indexed).
 */
export default function PageSeo({ title, description, path = "/", image = "/images/hero.jpg" }) {
  const canonical = `https://thebarracksbistro.in${path}`;
  const ogImage = image.startsWith("http") ? image : `https://thebarracksbistro.in${image}`;
  return (
    <Helmet>
      <title>{title}</title>
      <meta name="description" content={description} />
      <link rel="canonical" href={canonical} />
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:url" content={canonical} />
      <meta property="og:image" content={ogImage} />
      <meta property="og:type" content="website" />
      <meta name="twitter:card" content="summary_large_image" />
    </Helmet>
  );
}
